// Modules
import { api, customApi } from "services/api/service";

// Constants
import {
	API_REJECT_DECLARATION,
	API_GET_REIMB_SUMMARY_LIST,
	API_REIM_VERIFICATION_APPROVE_CLAIM,
	API_GET_REIMB_DETAILS,
	API_GET_TENANT_REIMB_SETTLEMENT_REP,
	API_GET_ADMIN_REIMB_REJECTION_REP,
	API_GET_ADMIN_REIMB_VOUCHER_REP,
	API_ACCEPT_DECLARATION,
	API_APPROVE_REIMBURSEMENT,
	// API_GET_VOUCHER_DETAILS_REP,
	API_GET_TENANT_VOUCHER_REDEMPTION_REP,
	API_GET_ADHOC_ADMIN_REP,
	API_GET_RETRO_CLAIM_REP
} from "constants/api";

// Imported definitions
import type {
	ApiResponse,
	RejectDeclarationResponse,
	AcceptMonthlyDeclarationResponse,
	GetReimbSummaryResponse,
	ApproveOrRejectResponse,
	ReimVerificationApprovalClaimDetails,
	GetReimbDetailsResponseMonthlyDeclarations,
	TenantReimbSettlementReport,
	GetVoucherDetailsReportPayload,
	GetVoucherDetailsReportResponse,
	AdHocReportResponse,
	RetroClaimReportPayload
} from "services/api/types";

// API to reject monthly declaration
export const rejectDeclaration = async (payload: any): Promise<ApiResponse<RejectDeclarationResponse>> => {
	return (await api()).post(API_REJECT_DECLARATION, payload, { headers: { "Content-Type": "multipart/form-data" } });
};

// API to accept Declaration
export const acceptMonthlyDeclaration = async (payload: any): Promise<ApiResponse<AcceptMonthlyDeclarationResponse>> => {
	return (await api()).post(API_ACCEPT_DECLARATION, payload);
};
// API to get the reimbursement summary

export const getMonthlyReimbSummaryData = async (payload: any): Promise<ApiResponse<GetReimbSummaryResponse>> => {
	return (await api()).post(API_GET_REIMB_SUMMARY_LIST, payload);
};

export const approveOrRejectClaim = async (payload: any): Promise<ApiResponse<ApproveOrRejectResponse>> => {
	return (await api()).post(API_REIM_VERIFICATION_APPROVE_CLAIM, payload);
};

export const approveReimbursement = async (payload: any): Promise<ApiResponse<ApproveOrRejectResponse>> => {
	return (await api()).post(API_APPROVE_REIMBURSEMENT, payload);
};

// API to get the reimbursement month details
export const getReimbDetailsMonthlyDeclarations = async (payload: any): Promise<ApiResponse<GetReimbDetailsResponseMonthlyDeclarations>> => {
	return (await api()).post(API_GET_REIMB_DETAILS, payload);
};

// API to get claim details
export const getReimClaimDetails = async (payload: any): Promise<ApiResponse<ReimVerificationApprovalClaimDetails>> => {
	return (await api()).post(API_GET_REIMB_SUMMARY_LIST, payload);
};

type TenantReimbSettlementReportPayload = {
	from_year_month: string;
	to_year_month: string;
	outlets: string[];
	voucher_group_code: string;
};

type TenantVouRedemptionReportPayload = {
	from_date: string;
	to_date: string;
	outlets: string[];
	voucher_group_code: string;
};

// GET Tenant Settlement report
export const getTenantReimbSettlementReport = async (payload: TenantReimbSettlementReportPayload): Promise<ApiResponse<TenantReimbSettlementReport>> => {
	return (await api()).post(API_GET_TENANT_REIMB_SETTLEMENT_REP, payload);
};

// GET Tenant Daily Voucher Redemption report
export const getTenantVouchRedemptionReport = async (payload: TenantVouRedemptionReportPayload): Promise<ApiResponse<TenantReimbSettlementReport>> => {
	return (await api()).post(API_GET_TENANT_VOUCHER_REDEMPTION_REP, payload);
};

type AdminReimbRejectionReportPayload = {
	from_year_month?: string;
	to_year_month?: string;
	outlet_code?: string;
	tenant_code?: string;
	voucher_group_code?: string;
	terminal?: string;
};

// GET Admin Reimb Rejection report
export const getAdminReimbRejectionReport = async (payload: AdminReimbRejectionReportPayload): Promise<ApiResponse<TenantReimbSettlementReport>> => {
	return (await api()).post(API_GET_ADMIN_REIMB_REJECTION_REP, payload);
};

export const getAdminReimbVoucherReport = async (payload: AdminReimbRejectionReportPayload): Promise<ApiResponse<TenantReimbSettlementReport>> => {
	return (await api()).post(API_GET_ADMIN_REIMB_VOUCHER_REP, payload);
};

export const getRetroClaimReport = async (payload: RetroClaimReportPayload): Promise<ApiResponse<TenantReimbSettlementReport>> => {
	return (await api()).post(API_GET_RETRO_CLAIM_REP, payload);
};

export const getAdhocAdminReport = async (payload: { smp_file_location: string }): Promise<ApiResponse<AdHocReportResponse>> => {
	return (await api()).post(API_GET_ADHOC_ADMIN_REP, payload);
};

// GET Monthly Reimbursement Voucher Report
export const getVoucherDetailsReport = async (payload: GetVoucherDetailsReportPayload): Promise<ApiResponse<GetVoucherDetailsReportResponse>> => {
	return (await customApi()).post("", payload);
};
